<div class="header"><app-header></app-header></div>

<div class="content">
  <router-outlet></router-outlet>
<!--  <ngx-spinner type="timer"><p style="color: white"> Laden...</p></ngx-spinner>-->
  <ngx-spinner type="pacman"><p style="color: white">{{getWaitMessage()}}</p></ngx-spinner>
</div>

<!--<div class="footer"><app-footer></app-footer></div>-->
